import dayjs from "dayjs";

// All colours tested for WCAG AA contrast (≥4.5:1) against white text
const AVATAR_COLORS = [
  "#4f46e5", // indigo-600
  "#7c3aed", // violet-600
  "#db2777", // pink-600
  "#e11d48", // rose-600
  "#dc2626", // red-600
  "#c2410c", // orange-700
  "#16a34a", // green-600
  "#0d9488", // teal-600
  "#0891b2", // cyan-600
  "#2563eb", // blue-600
  "#9333ea", // purple-600
  "#4338ca", // indigo-700
];

function stringToColor(string: string) {
  let hash = 0;
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export function formatAmount(value: string | number): string {
  const num = typeof value === "number" ? value : parseFloat(value);
  if (isNaN(num)) return String(value);
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

// Use months only below 18 months; switch to years (with optional remaining months) above.
export function formatAgeMonths(
  totalMonths: number,
  t: (key: string) => string,
): string {
  const m = Math.max(0, Math.floor(totalMonths || 0));
  if (m < 18) return `${m} ${t("labels.months").toLowerCase()}`;
  const years = Math.floor(m / 12);
  const rem = m % 12;
  const yearWord = years === 1 ? t("labels.year_age") : t("labels.years_age");
  if (rem === 0) return `${years} ${yearWord}`;
  return `${years} ${yearWord} ${rem} ${t("labels.months").toLowerCase()}`;
}

export function splitMonths(totalMonths: number): {
  years: number;
  months: number;
} {
  const m = Math.max(0, Math.floor(totalMonths || 0));
  return { years: Math.floor(m / 12), months: m % 12 };
}

export function formatChildAge(
  dateOfBirth: string | null | undefined,
  t: (key: string) => string,
): string | null {
  if (!dateOfBirth) return null;
  const dob = dayjs(dateOfBirth);
  if (!dob.isValid() || dob.isAfter(dayjs())) return null;
  const months = dayjs().diff(dob, "month");
  if (!Number.isFinite(months) || months < 0) return null;
  const years = Math.floor(months / 12);
  const rem = months % 12;
  const yearStr = `${years} ${t(years === 1 ? "labels.year_age" : "labels.years_age")}`;
  const monthStr = `${rem} ${t(rem === 1 ? "labels.month_age" : "labels.months_age")}`;
  return years > 0 ? `${yearStr}, ${monthStr}` : monthStr;
}

export function stringAvatar(name: string = "", sx: any = {}) {
  const parts = name.trim().split(" ");
  const first = parts[0]?.[0]?.toUpperCase() || "";
  const second = parts[1]?.[0]?.toUpperCase() || "";

  const avatarColor = stringToColor(name.trim() || "default");
  return {
    sx: {
      bgcolor: `${avatarColor} !important`,
      color: "#fff !important",
      fontWeight: 600,
      ...sx,
    },
    children: `${first}${second}`,
  };
}
